import BaseStyle from '@primevue/core/base/style';

const theme = ({ dt }) => `
.p-virtualscroller-loader {
    background: ${dt('virtualscroller.loader.mask.background')};
    color: ${dt('virtualscroller.loader.mask.color')};
}

.p-virtualscroller-loading-icon {
    font-size: ${dt('virtualscroller.loader.icon.size')};
    width: ${dt('virtualscroller.loader.icon.size')};
    height: ${dt('virtualscroller.loader.icon.size')};
}
`;

const css = `
.p-virtualscroller {
    position: relative;
    overflow: auto;
    contain: strict;
    transform: translateZ(0);
    will-change: scroll-position;
    outline: 0 none;
}

.p-virtualscroller-content {
    position: absolute;
    top: 0;
    left: 0;
    min-height: 100%;
    min-width: 100%;
    will-change: transform;
}

.p-virtualscroller-spacer {
    position: absolute;
    top: 0;
    left: 0;
    height: 1px;
    width: 1px;
    transform-origin: 0 0;
    pointer-events: none;
}

.p-virtualscroller-loader {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.p-virtualscroller-loader-mask {
    display: flex;
    align-items: center;
    justify-content: center;
}

.p-virtualscroller-horizontal > .p-virtualscroller-content {
    display: flex;
}

.p-virtualscroller-inline .p-virtualscroller-content {
    position: static;
}
`;

export default BaseStyle.extend({
    name: 'virtualscroller',
    css,
    theme
});
